module.exports = "<div mat-dialog-content class=\"bot-dialog\">\n    <ngx-json-viewer [json]=\"jsonData\"></ngx-json-viewer>\n</div>\n<div mat-dialog-actions>\n    <button class=\"btn btn-danger\" mat-button mat-dialog-close cdkFocusInitial\n        style=\"margin-right: 10px;\">Cancel</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/properJsonDialog/properjsondialog.component.html
// module id = ./src/app/properJsonDialog/properjsondialog.component.html
// module chunks = main